<div *ngFor="let section of sections">
  <div id="{{ section.heading }}" [innerHTML]="section.body | mdToHtml"></div>
  <app-news-content-page-note-section [noteSections]="section.noteSections || []"></app-news-content-page-note-section>
  <div [innerHTML]="section.subBody | mdToHtml"></div>
</div>
